import { ref } from "vue";

// para mantener la comarca seleccionada entre listados
const selectedComarcaId = ref<string | null>(null);

function setSelectedComarcaId(id: string | null) {
  const normalized = id && id.trim() ? id : null;
  selectedComarcaId.value = normalized;
}

export function useAdminComarca() {
  return { selectedComarcaId, setSelectedComarcaId };
}
